import React, { useEffect, useState } from 'react';
import { Header, Form, Icon, Loader, Modal,  ModalContent,TableCell, TableRow, TableBody, TableHeader, Table, TableHeaderCell, Input } from 'semantic-ui-react';
import {InventoryList, MetaDataTemplate } from '../../../app/models/TitleCreate';
import { useStore } from "../../../app/stores/store";
import 'semantic-ui-css/semantic.min.css';
import { CSSProperties } from 'react';
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import { CSVLink } from "react-csv";
const gridContainerStyle:CSSProperties  = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '16px',
};

const gridItemStyle:CSSProperties  = {
  display: 'flex',
  flexDirection: 'column',
};

interface csvFields {
  reel_Name:string;
  start_Frame:number;
  end_Frame:number;
  }
const CGRegister = ( ) => {
  const { RestorationStore,userStore: { user }} = useStore();
  const [inputFields, setInputFields] = useState<MetaDataTemplate[]>([]);
  const [loading, setloading]=useState<boolean>(false);
  const [deliveryDate, setDeliveryDate] = useState<Date | null>(new Date());
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [formErrors, setFormErrors] = useState<{ [key: string]: string }>({});
  const [totalFrameValue,setTotalFrameValue]=useState<number>(0);
  const [formValues, setFormValues] = useState<{ [key: string]: string | string[] }>(inputFields.reduce((acc: any, curr) => {acc[curr.elementName] = curr.elementValue || '';
      return acc;
    }, {})
  ); 
  const [csvData, setCsvData] = useState<csvFields[]>([]);
  const csvHeaders = [{ label: 'Reel Name', key: 'reel_Name' },{ label: 'Start Frame', key: 'start_Frame' },{ label: 'End Frame', key: 'end_Frame' }]; 
  const handleFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setCsvData([]);
    const file = event.target.files?.[0];
    if (!file) return;
    if(file.size > 1*1024*1024){
      toast.error("File size exceeds limit!");
      return;
    }
    const reader = new FileReader();
    reader.onload = (e) => {
    const text = e.target?.result as string;
    const rows = text.split('\n');
    const filteredData = rows.slice(1).filter((item) => item.trim() !== '');
    const existingReelNames = new Set(csvData.map(item => item.reel_Name));
    const parsedData: csvFields[] = filteredData.map((row) => {
        const [reel_Name, start_Frame, end_Frame] = row
          .replace(/\r/g, '')
          .split(',')
          .map((item) => item.trim());
          if (existingReelNames.has(reel_Name)) {
            toast.warning(`Please Check Reel Name Duplicates  ${reel_Name}`);
            return null;
          }   
          const startFrameInt = parseInt(start_Frame, 10);
          const endFrameInt = parseInt(end_Frame, 10);
          const totalFrame = (endFrameInt - startFrameInt) + 1;
          setTotalFrameValue(prevTotal => prevTotal + totalFrame);
          existingReelNames.add(reel_Name);
        return {
              reel_Name,
              start_Frame: startFrameInt,
              end_Frame: endFrameInt,
            };
          }).filter((item): item is csvFields => item !== null);
      setCsvData(prevData => [...prevData, ...parsedData]);
      };
      reader.readAsText(file);
    }; 

    const TemplateAPI = async () => {
      await RestorationStore.MetaDatafieldsName();
      setInputFields(RestorationStore.MetaDatatemplate);};
    useEffect(() => {
      TemplateAPI();
      // eslint-disable-next-line
    }, []);
  const HandleSubMit = async () => {
   
    if(csvData.length===0)
      {
        toast.error('Please Update Reel Details');
        return;
      }
      if(inputFields.some(x=>(x.elementName!=='Frames'&& x.elementName!=='Number of Reels') && (x.elementValue===''||x.elementValue===null||x.elementValue===undefined)))
      {
        toast.error('Please Fill Valid Data ');
        return;
      }
    try {
  setloading(true);
  const baseUrl = window.location.origin;
  const Data = await RestorationStore.CreateSingle(inputFields);
  let input=String(Data);
  const titleCode=inputFields.filter(x=>x.elementName==='Title Code').map(x=>x.elementValue)[0];
  const updatedInventoryData: InventoryList[] = csvData.map(data => ({
        title_Code: titleCode,  // Update with your title_Code
        reel_Name: data.reel_Name,
        start_Frame: data.start_Frame,
        end_Frame: data.end_Frame,
      }));
  await RestorationStore.CreateTitleReelInventory(input,updatedInventoryData)
  toast.success("Title Create Sucessfully");
  const relativePath ='/mediaAssets/'+ input;
  const fullUrl = baseUrl + relativePath;
  setloading(false);
  window.location.href = fullUrl;
    } catch (error) {
     
      setloading(false);
      toast.error('Some went wrong , Please try again');
    }
    
    }
  const DateUpdate = (date: Date | null, label: string) => {
   
    if(label === 'Delivery_Date') {
      setDeliveryDate(date);
    }
    else if (label === 'Start Date') {
      setStartDate(date);
    }
    let formattedDate = '';
    if (date) {
        formattedDate = format(date, 'dd/MM/yyyy');
    }
    setInputFields(prevFields => 
      prevFields.map(field => 
        field.elementName === label ? { ...field, elementValue: formattedDate  } : field
      )
    );
  };
  const HandleChangeValue=(e:any,label:string,validation:string)=>{
  const { value } = e.target;  
  if (validation === 'Numeric' && isNaN(value)) {
      
        setFormErrors({ ...formErrors, [label]: 'Invalid Data' });
      } else {
        const { [label]: removedError, ...rest } = formErrors;
        setFormErrors(rest);
      }
      setInputFields(prevFields => 
        prevFields.map(field => 
          field.elementName === label ? { ...field, elementValue: value } : field
        )
      );
    };
  const handleDropdownChange = (e: any, data: any) => {
  const { name, value } = data;
  let newValue = value;
  if (Array.isArray(value)){
        newValue = value.join(',').replace(/,/g, '|');
       
      }
      setFormValues(prevValues => ({
        ...prevValues,
        [name]: value,
      }));
      setInputFields(prevFields =>
        prevFields.map(field =>
          field.elementName === name ? { ...field, elementValue: String(newValue) } : field
        )
      );
    };

  return (
    <div>
      <br />
      <Header color="grey" as='h4'>TITLE INFORMATION</Header>
      <hr />
      <Form>
        {inputFields.length > 0 && (
          <div style={gridContainerStyle}>
            {inputFields.map((data, index) => (
              <div style={gridItemStyle} key={index}>
                <label htmlFor={data.elementName}>{data.elementName}{formErrors[data.elementName] && (<Icon name='exclamation circle' color='red' />)}</label>
                {data.elementType === 'DropDown' ? (
                  <Form.Dropdown className='ui input focus'
                    id={data.elementName}
                    name={data.elementName}
                    placeholder={data.elementName}
                    fluid
                    multiple={data.isMultiple}
                    options={data?.option?.map(opt=>({
                      key: opt.key,
                      text: opt.text,
                      value: opt.value,
                    }))}
                    value={formValues[data.elementName] as string | string[]} 
                    error={formErrors[data.elementName] ? { content: formErrors[data.elementName] } : false}
                    onChange={handleDropdownChange}
                  />
                ) : (data.elementType === 'DatePicker' ? (
                  
                  <DatePicker
                  selected={data.elementName === 'Delivery_Date' ? deliveryDate : startDate}
                  onChange={(date:Date) => DateUpdate(date, data.elementName)}
                />
                
              ) : 
                (
                  <Form.Input
                    className={`ui input ${formErrors[data.elementName] ? 'error' : ''}`}
                    id={data.elementName}
                    name={data.elementName}
                    type={data.elementType}
                    placeholder={data.elementName}
                    onChange={(e) => HandleChangeValue(e, data.elementName, data.validation)}
                    value={
                      data.elementName === 'Frames'
                      ? totalFrameValue :  data.elementName === 'Number of Reels' ?  csvData.length : data.elementValue
                    }
                    error={formErrors[data.elementName] ? { content: formErrors[data.elementName] } : false}
                    readOnly={data.elementName === 'Frames' || data.elementName === 'Number of Reels'}
                  /> 
                  ))}
              </div>
            ))}
          </div>
        )}
        <br/>
        <div>
        {user?.customerName==='Restoration' && (<>
     <div>Title Inventory</div>
      <Form.Group widths="equal">
        <Form.Field style={{ display: 'flex' }}>
          <Input type="file" onChange={handleFileUpload} />
          <CSVLink data={csvData} headers={csvHeaders} filename={'Inventory_Details.csv'}>
            <Icon
              style={{ marginTop: '5px', marginLeft: '400px' }}
              corner="bottom right"
              size="large"
              circular
              inverted
              color="teal"
              name="file excel outline"
            />
          </CSVLink>
        </Form.Field>
      </Form.Group>
      { csvData.length !==0 && (
        <>
      <Table>
        <TableHeader>
        <TableRow>
        <TableCell >No Of Reel Upload : {csvData.length}</TableCell>
        </TableRow>
          <TableRow>
            <TableHeaderCell>Reel Name</TableHeaderCell>
            <TableHeaderCell>Start Frame</TableHeaderCell>
            <TableHeaderCell>End Frame</TableHeaderCell>
            <TableHeaderCell>Total Frame</TableHeaderCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {csvData.map((rowData, index) => (
            <TableRow key={index}>
              <TableCell>{rowData.reel_Name}</TableCell>
              <TableCell>{rowData.start_Frame}</TableCell>
              <TableCell>{rowData.end_Frame}</TableCell>
              <TableCell>{(rowData.end_Frame - rowData.start_Frame) + 1}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>)}
    </>)}
        </div>
    <br/>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',}}>
            <button className="ui inverted green button" onClick={HandleSubMit}>Create Title</button>
        </div>
      </Form>
      
        <Modal open={loading}  className='ui basic modal'>
        <ModalContent>
        <Loader active inline='centered'>Please wait, this will take a few minutes...</Loader>
        </ModalContent>
        </Modal>
     
    </div>
  );
};

export default CGRegister;
